export const navItems = [
	{
		title: "GENERAL",
		link: "/general/overview/home",
		activePrefix: "/general",
		isExternal: false,
	},
	{
		title: "SPACES",
		link: "/spaces/spaces-overview/intro",
		activePrefix: "/spaces",
		isExternal: false,
	},
	{
		title: "SMART NFT",
		link: "/smart-nft/overview/intro",
		activePrefix: "/smart-nft",
		isExternal: false,
	},

/*--- Enable WALLET docs once Experience & Wallet SDKs are ready for release. ---*/
	{
		title: "WALLET",
		link: "/wallet/about-vatom-wallet/intro",
		activePrefix: "/wallet",
		isExternal: false,
	},
/*---*/

	{
		title: "REST API",
		link: "/api/general/overview/introduction",
		activePrefix: "/api",
		isExternal: false,
	}
];

export const bentoMenuItems = [
	{
		url: "https://market.vatom.com/",
		icon: "market-icon.svg",
		title: "Market",
	},
	{
		url: "https://www.spatialweb.net/",
		icon: "spaces-icon.svg",
		title: "Spaces",
	},
	{
		url: "https://studio.vatominc.com/",
		icon: "studio-icon.svg",
		title: "Studio",
	},
	{
		url: "https://wallet.vatom.com/",
		icon: "wallet-icon.svg",
		title: "Wallet",
	},
];
